import React, { Component } from 'react';
import '../css/skills.css'
import {
    Code,
    FileCode,
    Database,
    Cpu,
    GitBranch,
    Monitor,
    Palette
} from 'lucide-react';
import { LanguageContext } from '../contexts/LanguageContext';


class Skills extends Component {
    static contextType = LanguageContext

    state = {}
    render() {
        const { translations } = this.context;

        return (
            <section id='skills'>
                <div className='skills-container'>
                    <div className='skills-wrapper'>
                        <h1 className='skills-title'>{translations?.skills_page_title}</h1>
                        <p>{translations?.skills_page_description}</p>
                        <ul>
                            <li className='skill'>
                                <FileCode size={22} />
                                <span>HTML</span>
                            </li>
                            <li className='skill'>
                                <FileCode size={22} />
                                <span>CSS</span>
                            </li>
                            <li className='skill'>
                                <FileCode size={22} />
                                <span>JavaScript</span>
                            </li>
                            <li className='skill'>
                                <Code size={22} />
                                <span>LUA</span>
                            </li>
                            <li className='skill'>
                                <Database size={22} />
                                <span>SQL</span>
                            </li>
                            <li className='skill'>
                                <GitBranch size={22} />
                                <span>GitHub</span>
                            </li>
                            <li className='skill'>
                                <Palette size={22} />
                                <span>After Effects</span>
                            </li>
                            <li className='skill'>
                                <Code size={22} />
                                <span>React.js</span>
                            </li>
                            <li className='skill'>
                                <Code size={22} />
                                <span>Python</span>
                            </li>
                            <li className='skill'>
                                <Monitor size={22} />
                                <span>Frontend</span>
                            </li>
                            <li className='skill'>
                                <Cpu size={22} />
                                <span>Pm2</span>
                            </li>
                            <li className='skill'>
                                <Palette size={22} />
                                <span>Photoshop</span>
                            </li>
                            <li className='skill'>
                                <Code size={22} />
                                <span>Visual Studio Code</span>
                            </li>
                            <li className='skill'>
                                <Code size={22} />
                                <span>Java</span>
                            </li>

                        </ul>
                    </div>
                </div>
            </section>
        );
    }
}

export default Skills;